import React, { useEffect } from "react";
import styled from "styled-components";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
import Container from "../../../Components/Container";
import BGInstall from "./assets/BG@2x.png";
import Panel from "./assets/HanwhaPanel.png";
import { motion, AnimatePresence } from "framer-motion";

const HowWorksStyles = styled.div`
  display: grid;
  color: white;
  z-index: 2;
  width: 100%;
  height: 100%;
  grid-template-columns: 1fr 1fr;

  h1 {
    margin: 0;
    display: grid;
    align-self: center;
    font-size: 54px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .left-side {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;

    h2 {
      white-space: nowrap;
      margin: 0;
    }
  }

  .right-side {
    display: grid;
    align-items: center;
    justify-items: end;
    position: absolute;

    img {
      width: 140%;
    }
  }

  .point-copy {
    display: grid;
  }
`;

const container = {
  hidden: { opacity: 0 },

  show: {
    opacity: 1,
    transition: {
      staggerChildren: 1,
      delay: 1,
    },
  },
};

const item = {
  hidden: { opacity: 0, x: -200 },
  show: { opacity: 1, x: 100, transition: { duration: 1 } },
};

const items = [
  {
    header: "INNOVATIVE ALL-WEATHER TECHNOLOGY",
    copy: [
      "Optimal yields, whatever the weather with",
      "excellent low-light and temperature behavior",
    ],
  },
  {
    header: "EXTREME WEATHER RATING",
    copy: [
      "High-tech aluminum alloy frame,",
      "certified for high snow and wind loads",
    ],
  },
  {
    header: "A RELIABLE INVESTMENT",
    copy: ["25-year linear performance warranty"],
  },
  {
    header: "STATE OF THE ART MODULE TECHNOLOGY",
    copy: ["Top-tier panels made to last and produce energy for years to come"],
  },
];

const HowWorks = () => {
  useEffect(() => {
    console.log("mounts");
  }, []);
  return (
    <Container>
      <BGImageDisplay bgimage={BGInstall}></BGImageDisplay>
      <HowWorksStyles>
        <AnimatePresence exitBeforeEnter>
          <motion.div
            transition={{ delay: 10 }}
            variants={container}
            initial="hidden"
            animate="show"
            className="left-side"
          >
            <motion.h1 variants={item}>Top-tier Panels</motion.h1>

            {items.map(({ header, copy }) => (
              <motion.div key={header} variants={item} className="point">
                <h2 className="point-header">{header}</h2>

                <div className="point-copy">
                  {copy.map((lineitem) => (
                    <span className="point-line"> {lineitem} </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 300, x: 700, scale: 0.6 }}
            animate={{
              opacity: 1,
              y: 90,
              x: 660,
              scale: 1,
            }}
            transition={{ duration: 2, delay: 1 }}
            exit={{ opacity: 0, y: -600, x: 225, scale: 0.6 }}
            className="right-side"
          >
            <img
              alt="how-does-it-work"
              onClick={(e) => e.preventDefault()}
              src={Panel}
            />
          </motion.div>
        </AnimatePresence>
      </HowWorksStyles>
    </Container>
  );
};

export default HowWorks;
